import { Component, effect } from '@angular/core';
import { MdmSignalsService } from 'src/app/features/mdm/services/mdm-signals.service';

@Component({
  selector: 'app-mdm-nav-toggle-btn-rounded',
  templateUrl: './mdm-nav-toggle-btn-rounded.component.html',
  styleUrls: ['./mdm-nav-toggle-btn-rounded.component.scss'],
})
export class MdmNavToggleBtnRoundedComponent {
  isNavbarVisible: boolean = true;
  constructor(private mdmSignalService: MdmSignalsService) {
    effect(() => {
      this.isNavbarVisible = this.mdmSignalService.navbarVisible();
    });
  }

  toggleNavbar() {
    this.mdmSignalService.toggleNavbarVisibility(); // Call the service to toggle the navbar visibility
  }
}
